const state = {
  loading: false,
};
const mutations = {
  setGlobalLoading(state, status) {
    if (!status) {
      setTimeout(() => {
        state.loading = false;
      }, 500);
    } else {
      state.loading = true;
    }
  },
};
const actions = {
  setGlobalLoading({ commit }, status) {
    commit('setGlobalLoading', status);
  },
};
export default {
  state,
  mutations,
  actions,
};
